
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PremiumServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  delay?: number;
}

const PremiumServiceCard: React.FC<PremiumServiceCardProps> = ({ 
  title, 
  description, 
  icon: Icon,
  delay = 0 
}) => {
  return (
    <div 
      className="card-elegant group hover:shadow-elegant-lg hover:-translate-y-1 h-full flex flex-col"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="text-center flex-1 flex flex-col">
        <div className="flex justify-center mb-5">
          <div className="p-4 bg-primary-brand rounded-xl group-hover:scale-110 transition-transform duration-300">
            <Icon className="h-8 w-8 text-white" />
          </div>
        </div>
        
        {/* Fixed height container for titles with top alignment */}
        <div className="h-16 flex items-start justify-center mb-3">
          <h3 className="text-xl font-semibold text-primary-brand leading-tight text-center">
            {title}
          </h3>
        </div>
        
        <div className="flex-1 flex items-start">
          <p className="text-gray-600 leading-relaxed text-center">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PremiumServiceCard;
